export default __webpack_public_path__ + "img/op-home-mixing.be303303.png";